"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _SVGIcon = _interopRequireDefault(require("@instructure/ui-svg-images/lib/components/SVGIcon"));

var _ref =
/*#__PURE__*/
_react.default.createElement("path", {
  d: "M1458.948 1305.626c104.637-136.95 167.527-307.187 167.527-492.388C1626.475 364.764 1261.711 0 813.238 0 364.764 0 0 364.764 0 813.238c0 448.473 364.764 813.237 813.238 813.237 185.201 0 355.547-62.89 492.496-167.527L1766.678 1920 1920 1766.678l-461.052-461.052zm-645.71 103.986c-328.874 0-596.375-267.61-596.375-596.374 0-328.765 267.501-596.375 596.375-596.375 328.873 0 596.374 267.61 596.374 596.375s-267.501 596.374-596.374 596.374z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconSearch =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(IconSearch, _Component);

  function IconSearch() {
    (0, _classCallCheck2.default)(this, IconSearch);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(IconSearch).apply(this, arguments));
  }

  (0, _createClass2.default)(IconSearch, [{
    key: "render",
    value: function render() {
      return _react.default.createElement(_SVGIcon.default, Object.assign({}, this.props, {
        name: "IconSearch",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);
  IconSearch.displayName = "IconSearch";
  return IconSearch;
}(_react.Component);

exports.default = IconSearch;
IconSearch.glyphName = 'search';
IconSearch.variant = 'Solid';
IconSearch.propTypes = (0, _objectSpread2.default)({}, _SVGIcon.default.propTypes);